import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
const IcoMaestro24 = t0 => {
  const $ = _c(6);
  const {
    "aria-label": ariaLabel,
    className
  } = t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M6.06543 3.86414C9.41528 3.86414 12.1307 6.61118 12.1309 9.99988C12.1309 13.3887 9.41537 16.1366 6.06543 16.1366C2.71557 16.1365 0 13.3886 0 9.99988C0.00014316 6.61123 2.71566 3.86423 6.06543 3.86414Z" fill="#ED0006" />;
    t2 = <path d="M13.9341 3.86414C17.2839 3.86414 19.9994 6.61118 19.9995 9.99988C19.9995 13.3887 17.284 16.1366 13.9341 16.1366C10.5842 16.1365 7.86865 13.3886 7.86865 9.99988C7.8688 6.61123 10.5843 3.86423 13.9341 3.86414Z" fill="#0099DF" />;
    t3 = <path d="M9.99951 5.3313C11.3035 6.45674 12.1313 8.13034 12.1313 10.0002C12.1313 11.8699 11.3032 13.5428 9.99951 14.6682C8.69608 13.5428 7.86865 11.8697 7.86865 10.0002C7.86867 8.13056 8.69578 6.45674 9.99951 5.3313Z" fill="#6C6BBD" />;
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] !== ariaLabel || $[4] !== className) {
    t4 = <svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={true}>{t1}{t2}{t3}</svg>;
    $[3] = ariaLabel;
    $[4] = className;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};
export default IcoMaestro24;